export const BUYER_FEES_BASED_ON_VALUE_TIERS = {
    tier1: 0.144,
    tier2: 0.13,
    tier3: 0.12
}

export const VALUE_TIERS_MAX_THRESHOLD = {
    tier1: 5000,
    tier2: 15000,
    tier3: Number.MAX_VALUE
}

export const PRICE_RANGE_VALUES = {
    low: 0.9,
    high: 1.2
}

export const shapesData = ['Round', 'Princess', 'Radiant', 'Marquise', 'Pear', 'Heart', 'Asscher', 'Cushion', 'Oval', 'Emerald']

export const colorsData = ['D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L']

export const clarityData = ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2', 'I1', 'I2', 'I3']